import type { theme } from "../tokens"

export type ColorsType = keyof typeof theme | "transparent" | "current"

export const getCSSVariableThemeColor = (colorThemeName: ColorsType) => {
  return `var(--c-${colorThemeName})`
}

export const getComputedThemeColor = (colorThemeName: ColorsType) => {
  if (colorThemeName === "current") return "currentColor"
  if (colorThemeName === "transparent") return "transparent"

  const styles = getComputedStyle(document.documentElement)
  return styles.getPropertyValue(`--c-${colorThemeName}`)
}

export const getA11yOnClick = <T extends HTMLElement>(
  onClick: (e: React.MouseEvent<T> | React.KeyboardEvent<T>) => void,
) => ({
  onClick,
  onKeyUp: (e: React.KeyboardEvent<T>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      onClick(e)
    }
  },
})
